<template src="./u-icon.html" />
<script src="./u-icon.ts" lang="ts"></script>
<style src="./u-icon.scss" scoped lang="scss"></style>
